import React from "react";
import { Flex } from "@chakra-ui/react";
import { FiCheckCircle, FiPrinter } from 'react-icons/fi';
import { ROUTES } from "constants/routes-path";
import CardList from "components/Card/CardList";
import IconWithBadge from "components/CustomIcon/IconWithBadge";

function ViolationAllotmentsList() {
    const violationAllotmentsConfig = [
        {
            icon: FiCheckCircle, 
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.violationAllotmentsValidation}`,
            titleKey: "violation-allotments.title",
            descriptionKey: "violation-allotments.description",
        },
        {
            icon: <IconWithBadge icon={FiPrinter} label="NAs" />,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.violationAllotments}${ROUTES.violationAllotmentsPrintingNAs}`,
            titleKey: "print-nas.title",
            descriptionKey: "print-nas.description",
        },
        {
            icon: <IconWithBadge icon={FiPrinter} label="NPs" />,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.violationAllotments}${ROUTES.violationAllotmentsPrintingNPs}`,
            titleKey: "print-nps.title",
            descriptionKey: "print-nps.description",
        },
    ];

    return (
        <Flex
            gap="5"
            direction="column"
            pt={{ base: "180px", sm: "155px", lg: "90px" }}
            px="30px"
        >
            <CardList items={violationAllotmentsConfig} />
        </Flex>
    );
}

export default ViolationAllotmentsList;